module.exports = __webpack_public_path__ + "img/bg-sm.f94e914d.png";